import { render, staticRenderFns } from "./GestionCursoPage.vue?vue&type=template&id=e1ee848c&scoped=true&"
import script from "./GestionCursoPage.vue?vue&type=script&lang=js&"
export * from "./GestionCursoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1ee848c",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/GestionCursoPage.vue
// module id = 209
// module chunks = 26